"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    padding: 15px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    padding: 3px 15px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: 7px 15px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    max-height: 32px;\n    padding: 4px 16px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    max-height: 40px;\n    padding: 8px 16px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    max-height: 56px;\n    padding: 16px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paddingOnFocusDefault = exports.paddingOnFocusCompact = exports.paddingOnFocusComfortable = exports.compactDensity = exports.comfortableDensity = exports.defaultDensity = void 0;

var _stylitas = require("@creditas/stylitas");

var defaultDensity = function defaultDensity(_ref) {
  var size = _ref.size;
  return size === 'default' && (0, _stylitas.css)(_templateObject());
};

exports.defaultDensity = defaultDensity;

var comfortableDensity = function comfortableDensity(_ref2) {
  var size = _ref2.size;
  return size === 'comfortable' && (0, _stylitas.css)(_templateObject2());
};

exports.comfortableDensity = comfortableDensity;

var compactDensity = function compactDensity(_ref3) {
  var size = _ref3.size;
  return size === 'compact' && (0, _stylitas.css)(_templateObject3());
};

exports.compactDensity = compactDensity;

var paddingOnFocusComfortable = function paddingOnFocusComfortable(_ref4) {
  var size = _ref4.size,
      inputFocus = _ref4.inputFocus,
      readOnly = _ref4.readOnly;
  return inputFocus && !readOnly && size === 'comfortable' && (0, _stylitas.css)(_templateObject4());
};

exports.paddingOnFocusComfortable = paddingOnFocusComfortable;

var paddingOnFocusCompact = function paddingOnFocusCompact(_ref5) {
  var size = _ref5.size,
      inputFocus = _ref5.inputFocus,
      readOnly = _ref5.readOnly;
  return inputFocus && !readOnly && size === 'compact' && (0, _stylitas.css)(_templateObject5());
};

exports.paddingOnFocusCompact = paddingOnFocusCompact;

var paddingOnFocusDefault = function paddingOnFocusDefault(_ref6) {
  var size = _ref6.size,
      inputFocus = _ref6.inputFocus,
      readOnly = _ref6.readOnly;
  return inputFocus && !readOnly && size === 'default' && (0, _stylitas.css)(_templateObject6());
};

exports.paddingOnFocusDefault = paddingOnFocusDefault;